import { PcApiResponse } from '@/api/pc-api/types';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type SvcCompact = {
  id: string;
  svcName: string;
};

export const getSvcListCompact = () => {
  return api<PcApiResponse<SvcCompact[]>>('get', `/pc-api/v1/${PREFIX_PATH}/svc/list/compact`);
};
